import type { UserRole } from '@/stores/slices/selected-user-config';

export const CHAT_QUERY_KEYS = {
  threads: 'threads',
  recipient: 'recipient',
  recipientEntities: 'recipient-entities',
  messages: 'messages',
  replyThread: 'reply-thread',
  contexts: 'contexts',
  contextThreads: 'context-threads',
  contextThreadsPaged: 'context-threads-paged',
  contextMessages: 'context-messages',
  contextSummary: 'context-summary',
  topics: 'topics',
  participants: 'participants',
} as const;

type ChatQueryKeyRoot = (typeof CHAT_QUERY_KEYS)[keyof typeof CHAT_QUERY_KEYS];

export type ChatIdentityKey = string;

export const toChatIdentityKey = (role: UserRole, entityId: string | null): ChatIdentityKey =>
  role === 'entity' ? `entity:${entityId ?? 'unselected'}` : role;

export const chatQueryKey = (
  identity: ChatIdentityKey,
  root: ChatQueryKeyRoot,
  ...rest: readonly unknown[]
): unknown[] => [root, identity, ...rest];

export const chatQueryKeyIdentity = (queryKey: readonly unknown[]): ChatIdentityKey | null =>
  typeof queryKey[1] === 'string' ? queryKey[1] : null;
